/* AMPER - copiar descuento sin ventanas emergentes */
(function () {
  if (window.amperCouponInitialized) return;
  window.amperCouponInitialized = true;
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('.amper-coupon');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var code = button.getAttribute('data-amper-code');
    var label = button.querySelector('.amper-coupon__code-text');
    var status = button.parentElement.querySelector('.amper-coupon__feedback');
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        var field = document.createElement('textarea');
        field.value = code;
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        var copied = document.execCommand('copy');
        field.remove();
        if (!copied) throw new Error('copy failed');
      }
      button.classList.add('is-copied');
      label.textContent = '¡COPIADO!';
      if (status) status.textContent = 'Cupón OTOÑO10 copiado correctamente';
      clearTimeout(button.amperCouponTimer);
      button.amperCouponTimer = setTimeout(function () {
        button.classList.remove('is-copied');
        label.textContent = code;
      }, 2300);
    } catch (error) {
      if (status) status.textContent = 'No se pudo copiar automáticamente. Código: ' + code;
    }
  });
})();
